import React from "react";
import { Stack, Box } from "@chakra-ui/react";
import ContactSalesPage from "./components/contactSales";
import FormStructure from "./components/form";
const ContactUsPage = () => {
  return (
    <Box my={20}>
      <Stack
        direction={{ base: "column", md: "row" }}
        spacing={{ base: 6, md: 20 }}
        px={8}
        margin={"0 0 min(2rem, 4%) 0"}
        data-cy="section-contact-form"
        justifyContent={"center"}
        alignItems={"center"}
      >
        <FormStructure />
        <ContactSalesPage />
      </Stack>
    </Box>
  );
};

export default ContactUsPage;
